import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-value-with-label',
  templateUrl: './value-with-label.component.html',
  styleUrls: ['../../../shared/summaries/css-summary.component.scss']
})
export class ValueWithLabelComponent implements OnInit {
  @Input() label: string;
  @Input() value: string;
  @Input() breakLineBefore = false;
  @Input() breakLine = false;

  constructor() {}

  ngOnInit(): void {}
}
